import Axios from './Axios';
import { LOCAL_URL } from '../helper/constant'


class FAQ extends Axios {

    static async playMedia(item) {
        let link = item?.link
        let url = `${LOCAL_URL}/faqs/media/${item?.id}/${link?.hash}/${encodeURIComponent(link?.filename)}`
        window.open(url, '_blank')
    }

    static async getPortalFAQs(portalId) {
        if (!portalId) {
            return []
        }
        const url = `${LOCAL_URL}/faqs/portal/${portalId}`
        return new Promise((resolve, reject) => {
            this.axios.get(url).then((response) => {
                return resolve(response.data)
            })
                .catch((error) => {
                    return reject(error)
                })
        })
    }

    static async getFAQs() {
        const url = `${LOCAL_URL}/faqs`
        return new Promise((resolve, reject) => {
            this.axios.get(url).then((response) => {
                return resolve(response.data)
            })
                .catch((error) => {
                    return reject(error)
                })
        })
    }
}

export default FAQ